import React, { memo, useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { message, Spin } from 'antd'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import date_format from '../../date_format'
import { apiUrl } from './../../config'
import {
  PopupAvatar,
  PopupContentGroup,
  PopupItemDate,
  PopupItemLeft,
  PopupItemRight,
  PopupItemRow,
  PopupItemTitle,
  PopupListWrapper,
} from './PopupNotificationPageStyled'
import EmptyContent from '../../components/EmptyContent'
import { subStringAvatar, WordBreak } from '../../components/Common/CellText'
import { StatusTag } from '../../components/Common/StatusTag'
import { NOTIFICATION_STATUS, TYPE_STATUS } from '../../constants'
import internalMessageStore from '../../stores/internalMessageStore'

const PopupNotificationPage = props => {
  const {
    notificationStore,
    loadingAnimationStore,
    history,
    notificationListPageIndex,
    notificationListPageSize,
    onlyNewsNotification,
    changedTabsNotification,
    commandStore,
    setVisibleNotification,
  } = props

  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)

  /** Xử lý đã đọc thông báo */
  const handleReadNotify = useCallback(
    (id, status, num) => {
      if (status && num === 0) {
        message.warning('Thông báo đã được đọc!')
        return
      }
      if (status) return
      loadingAnimationStore.showSpinner(true)
      notificationStore
        .readNotification(id)
        .then(() => {
          const itemsList = [...items]
          const indexReadItem = items.findIndex(item => item.id === id)
          if (indexReadItem !== -1) {
            const itemReplace = {
              ...items[indexReadItem],
              status: true,
            }
            itemsList.splice(indexReadItem, 1, itemReplace)
            setItems([...itemsList])
          }
          if (!onlyNewsNotification) {
            notificationStore.setUnreadNotificationCount('remove')
          } else {
            notificationStore.setUnreadNewsCount('remove')
          }
          message.success('Thông báo được đánh dấu đã đọc!')
        })
        .finally(() => loadingAnimationStore.showSpinner(false))

      commandStore.getSideMenuCounter([
        'WORK',
        'PROPOSAL',
        'INTERNAL_MESSAGE',
        'INCOMING',
        'OUTGOING',
        'ELEC_DOC',
      ])
    },
    [commandStore, items, loadingAnimationStore, notificationStore, onlyNewsNotification]
  )

  const goToContentNotification = async (type, id) => {
    if (!type) return

    if (type.slice(0, 5) === 'OTHER') {
      return history.push(`/proposal/other/view/${id}`)
    }

    switch (type) {
      case NOTIFICATION_STATUS.OUTGOING:
        return history.push(`/internal-document/outgoing-document/view/${id}`)
      case NOTIFICATION_STATUS.INCOMING:
      case NOTIFICATION_STATUS.INTERNAL_DOCUMENT_COMMENT:
        return history.push(`/internal-document/incoming-document/view/${id}`)
      case NOTIFICATION_STATUS.VBLT_DI:
        return history.push(`/connected-document/outgoing-document/view/${id}`)
      case NOTIFICATION_STATUS.VBLT_DEN:
        return history.push(`/connected-document/incoming-document/view/${id}`)
      case NOTIFICATION_STATUS.WORK:
        return history.push(`/works/view/${id}`)
      case NOTIFICATION_STATUS.TASK:
        return history.push(`/mission/view/${id}`)
      case NOTIFICATION_STATUS.ELEC_DOC:
        return history.push(`/internal-document/sign-document/view/${id}`)
      case NOTIFICATION_STATUS.WORK_ELEC:
        return history.push(`/archiving-n-distribution/view/${id}`)
      case NOTIFICATION_STATUS.VEHICLE:
      case NOTIFICATION_STATUS.LEAVE:
      case NOTIFICATION_STATUS.LEAVE_ANNUAL:
      case NOTIFICATION_STATUS.LEAVE_ABNORMAL:
      case NOTIFICATION_STATUS.LEAVE_NO_SALARY:
      case NOTIFICATION_STATUS.SICK:
      case NOTIFICATION_STATUS.SICK_OTHER:
      case NOTIFICATION_STATUS.OVERTIME_NORMAL:
      case NOTIFICATION_STATUS.OVERTIME_DAYOFF:
      case NOTIFICATION_STATUS.OVERTIME_HOLIDAY:
      case NOTIFICATION_STATUS.OVERTIME_CHAIRMAN:
      case NOTIFICATION_STATUS.BUSINESS_TRIP:
      case NOTIFICATION_STATUS.EVALUATE_MEMBER:
      case NOTIFICATION_STATUS.EVALUATE_LEADER:
      case NOTIFICATION_STATUS.TIMEKEEPER:
      case NOTIFICATION_STATUS.STATIONERY:
      case NOTIFICATION_STATUS.RETIMEKEEPING:
      case NOTIFICATION_STATUS.MEETING:
      case NOTIFICATION_STATUS.PROPOSAL_SALARY:
        return history.push(`/proposal/other/view/${id}`)
      case NOTIFICATION_STATUS.CONSULT:
        return history.push(`/administrative/consult/view/${id}`)
      case NOTIFICATION_STATUS.POLICY:
        return history.push(`/administrative/policy/view/${id}`)
      case NOTIFICATION_STATUS.WORK_SCHEDULE:
        return history.push(`/company-work-schedule/view/${id}`)
      case NOTIFICATION_STATUS.GENERAL:
      case NOTIFICATION_STATUS.NEWS:
        return history.push(`/utility/general-notifications/view/${id}`)
      case NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING:
      case NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING_REPLY: {
        loadingAnimationStore.showSpinner(true)
        const internal_message_user_code =
          await internalMessageStore.getInternalMessageUserCodeByInternalMessageCode(
            id
          )
        loadingAnimationStore.showSpinner(false)
        return history.push(
          `/utility/internal-message/receive/view/${internal_message_user_code}`
        )
      }
      case NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING:
      case NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING_REPLY:
        return history.push(`/utility/internal-message/send/view/${id}`)
      default:
        return
    }
  }

  useEffect(() => {
    notificationStore.setFilter('notificationListPageIndex', 0)
    notificationStore.setFilter('notificationListPageSize', 10)
    ;(async () => {
      try {
        setLoading(true)
        if (
          changedTabsNotification.onlyNewsNotification === onlyNewsNotification
        ) {
          const { data } = await notificationStore.getCurrentUserNotification(
            onlyNewsNotification
          )
          setItems([...(data?.data || [])])
        }
      } catch (error) {
        console.log(error)
        message.error('Có lỗi xảy ra!')
      } finally {
        setTimeout(() => {
          setLoading(false)
        }, 300)
      }
    })()
  }, [
    notificationListPageIndex,
    notificationListPageSize,
    onlyNewsNotification,
    changedTabsNotification,
    notificationStore,
  ])


  const handleItemClick = item => {
    if (typeof setVisibleNotification === 'function') {
      setVisibleNotification(false)
    }
    handleReadNotify(item.id, item.status, 1)
    goToContentNotification(item.type, item.code)
  }

  return (
    <PopupListWrapper>
      {loading && items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '30px 0' }}>
          <Spin tip="Đang tải..." />
        </div>
      ) : items.length === 0 ? (
        <EmptyContent description="Không có thông báo!" />
      ) : (
        items.map(item => {
          return (
            <PopupItemRow
              key={item.id}
              isRead={item.status}
              onClick={() => handleItemClick(item)}>
              <PopupItemLeft>
                <PopupAvatar
                  src={
                    item.userImage
                      ? `${apiUrl}/api/v1/images/${item.userImage}`
                      : null
                  }>
                  {subStringAvatar(item.owner)}
                </PopupAvatar>
                <PopupContentGroup>
                  <PopupItemTitle isRead={item.status}>
                    {WordBreak(item.content ? item.content.trim() : '', true)}
                  </PopupItemTitle>
                  <PopupItemDate isRead={item.status}>
                    {date_format.renderTime(item.time_created)}
                  </PopupItemDate>
                </PopupContentGroup>
              </PopupItemLeft>

              <PopupItemRight>
                {StatusTag(TYPE_STATUS.NOTIFICATION, item.type)}
              </PopupItemRight>
            </PopupItemRow>
          )
        })
      )}
    </PopupListWrapper>
  )
}

PopupNotificationPage.propTypes = {
  notificationStore: PropTypes.object,
  loadingAnimationStore: PropTypes.object,
  history: PropTypes.object,
  notificationListPageIndex: PropTypes.number,
  notificationListPageSize: PropTypes.number,
  onlyNewsNotification: PropTypes.bool,
  changedTabsNotification: PropTypes.object,
  commandStore: PropTypes.object,
  setVisibleNotification: PropTypes.func,
}

export default memo(
  withRouter(
    inject(
      'notificationStore',
      'loadingAnimationStore',
      'commandStore'
    )(observer(PopupNotificationPage))
  )
)
